module.exports = {};



//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/node_modules/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = polyfills